import { searchLineweights } from '../../api/lineweights.api';
import { useAxiosInfiniteQuery } from './use-axios.hook';
import { SearchLineweightsApiRequest } from '../../../../types/requests/lineweights/search-lineweights.request';

const baseQueryKey = 'lineweight';
const searchQueryKey = 'search';

export const useLineweights = (params: SearchLineweightsApiRequest) => {
  const { data, ...result } = useAxiosInfiniteQuery({
    queryKey: [baseQueryKey, searchQueryKey, params],
    queryFn: async ({ pageParam }) => (await searchLineweights({ cursor: pageParam, ...params })).data,
    initialPageParam: params.cursor,
    getNextPageParam: (lastResponse) => lastResponse.nextCursor,
  });
  return { ...result, response: data } as const;
};
